import { useEffect, useRef } from 'react'
import { useCallbackRef } from './useCallbackRef'

export function useInterval(callback, delay) {
  const fn = useCallbackRef(callback)
  const intervalIdRef = useRef(null)

  function cleanup() {
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current)
    }
  }

  useEffect(() => {
    const tick = () => fn()

    if (delay !== null) {
      intervalIdRef.current = setInterval(tick, delay)
    }

    return cleanup
  }, [delay, fn])

  return cleanup
}
